export function triggerEvent( el, type ) {
    if ( 'createEvent' in document ) {
        // modern browsers, IE9+
        var e = document.createEvent( 'HTMLEvents' );
        e.initEvent( type, false, true );
        el.dispatchEvent( e );
    } else {
        // IE 8
        var e       = document.createEventObject();
        e.eventType = type;
        el.fireEvent( 'on' + e.eventType, e );
    }
}


/**
 *
 * @param eventName
 * @param detail bool|object
 */
export function dispatchWindowEvent(eventName, detail = false)
{

    let event;

    if ( detail )
    {
        event = new CustomEvent(eventName, {detail});
    }
    else
    {
        event = new CustomEvent(eventName);
    }

    window.dispatchEvent(event);
}


// https://stackoverflow.com/a/7228322
export function randomIntFromInterval(min, max) { // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
}
